<template>
  <div>
    <v-dialog
      v-model="dialog"
      v-bind="$attrs"
      class="base-modal"
      :width="width"
      @keydown.esc="$emit('esc:modal')"
      :persistent="persistent"
    >
      <v-card class="base-modal-card">
        <v-card-title v-if="persistent">{{ title }}
          <v-spacer></v-spacer>
          <v-btn v-if="!hideClose" icon @click="onCloseClick" :disabled="disableClose">
            <v-icon class="close-icon">&#10006;</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <slot name="content"></slot>
        </v-card-text>
        <v-card-actions>
          <slot name="actions"></slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "800"
    },
    persistent: {
      type: Boolean,
      default: false
    },
    disableClose: {
      type: Boolean,
      default: false
    },
    hideClose: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialog: null
    };
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.dialog = val;
      }
    },
    dialog: {
      handler(val) {
        this.$emit("change:modal", val);
      }
    }
  },
  methods: {
    onCloseClick() {
      if (this.disableClose) {
        return;
      }

      this.dialog = false;
    }
  }
};
</script>

<style lang="scss">
.base-modal {
  touch-action: manipulation;
}
.close-icon {
  width: 30px;
  height: 30px;
}
</style>
